<template>
  <v-dialog
    v-model="dialog"
    width="320"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-if="!job.allowBlankTimecardSubmission"
        v-model="textTime"
        :label="label"
        :rules="rules"
        v-bind="attrs"
        readonly
        placeholder="Click here to select week"
        :data-cy="dataCy"
        v-on="on"
      />
      <v-text-field
        v-else
        v-model="textTime"
        :label="label"
        v-bind="attrs"
        readonly
        placeholder="Click here to select week"
        :data-cy="dataCy"
        v-on="on"
      />
    </template>

    <div>
      <v-date-picker
        v-model="placeholder"
        ampm-in-title
        style="border-radius:0;width:100%"
        class="pt-0 mt-0"
        :allowed-dates="allowedDates"
        @update:picker-date="pickerUpdate($event)"
        @change="(val) => dateChange(val)"
      />
      <v-btn
        style="border-radius: 0;width:100%"
        :data-cy="`${dataCy}-button-submit`"
        @click="dialog=false"
      >
        Done
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { DateTime } from 'luxon';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    dataCy: {
      type: String,
      default: null,
    },
    job: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      rangeDates: [],
      availableDates: [],
      rules: [
        (value) => !!value || 'Must select a week.',
      ],
    };
  },
  computed: {
    textTime() {
      if (!this.value) return null;
      const firstDay = DateTime.fromFormat(this.value, 'yyyy-MM-dd').toFormat('MM/dd');
      const lastDay = DateTime.fromFormat(this.value, 'yyyy-MM-dd').plus({ day: 6 }).toFormat('MM/dd');

      return `${firstDay} - ${lastDay}`;
    },
    placeholder: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    allowedDates(a) {
      return this.availableDates.includes(a);
    },
    pickerUpdate(val) {
      const totalDay = moment(val, 'YYYY-MM').daysInMonth();
      const availableDates = [];

      for (let i = 1; i <= totalDay; i += 1) {
        const date = moment(val, 'YYYY-MM').month(val.split('-')[1] - 1).date(i).format('YYYY-MM-DD');
        if (moment(date).day() === 0) { availableDates.push(date); }
      }
      this.availableDates = availableDates;
      this.allowedDates();
    },
    dateChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style>

</style>
